import { useAppSelector } from '../../../store/hooks';
import { selectViewerMode } from '../../../store/slices/shareSlice';
import { companiesApi } from '../../../store/services/CompaniesService';
import { shareApi } from '../../../store/services/DashboardShareService';
import { TimeSeriesGranularity } from '../../../store/responseTypes/company';

export const useCompanyStatsTimeseriesQuery = (args: {
  companyId: string;
  fromDate: string;
  toDate: string;
  granularity?: TimeSeriesGranularity;
  metrics?: string;
}) => {
  const viewerMode = useAppSelector(selectViewerMode);
  return viewerMode
    ? shareApi.useGetCompanyStatsTimeseriesQuery(args)
    : companiesApi.useGetCompanyStatsTimeseriesQuery(args);
};
